import Icon from '@components/v2/ui/Icon/Icon';
import StatusChip from '@components/v2/ui/StatusChip/StatusChip';
import { NotepadText } from 'lucide-react';
import useMoney from '../../../../../../hooks/useMoney';
import { ORDER_STATUS_CHIP_CONFIG } from '../../../../../orders/list/components/orderStatusChip.constants';
import { OrderSearchResultItem } from '../../../../globalSearch.types';
import HighlightedText from '../../../HighlightedText';
import ResultRowBase from '../../ResultRowBase';
import { ResultRowRendererProps } from '../../resultRow.types';
import { formatOptionalMoney, joinResultParts } from '../../resultRow.utils';

function OrderRow({
  item,
  query,
  isActive,
  isDisabled,
  domId,
  onSelect,
}: ResultRowRendererProps<OrderSearchResultItem>) {
  const { formatMoney } = useMoney();

  const statusConfig = ORDER_STATUS_CHIP_CONFIG[item.status];
  const subtitle = joinResultParts([
    formatOptionalMoney(item.totalAmount, formatMoney),
    item.customerName,
  ]);

  return (
    <ResultRowBase
      testId={`global-search-item-${item.entityType}-${item.id}`}
      isActive={isActive}
      isDisabled={isDisabled}
      domId={domId}
      onClick={onSelect}
      leading={<Icon icon={NotepadText} size="md" />}
      title={<HighlightedText text={item.title} query={query} />}
      subtitle={subtitle ? <HighlightedText text={subtitle} query={query} /> : undefined}
      line1Trailing={statusConfig && <StatusChip {...statusConfig} />}
    />
  );
}

export default OrderRow;
